import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = forwardRef(({ showOnMount = true }, ref) => {
  const [showModal, setShowModal] = useState(false);
  const [accepted, setAccepted] = useState(false);

  // Exponer métodos para control externo
  useImperativeHandle(ref, () => ({
    openModal: () => {
      setShowModal(true);
      setAccepted(false); // Reset checkbox when opening manually
    },
    closeModal: () => {
      setShowModal(false);
    }
  }));

  useEffect(() => {
    // Solo mostrar automáticamente si showOnMount es true
    if (showOnMount) {
      // Limpiar localStorage para testing (remover en producción)
      // localStorage.removeItem('termsAccepted');
      
      // Verificar si ya aceptó los términos anteriormente
      const termsAccepted = localStorage.getItem('termsAccepted');

      if (!termsAccepted) {

        // Mostrar modal después de 3 segundos
        const timer = setTimeout(() => {

          setShowModal(true);
        }, 3000);

        return () => clearTimeout(timer);
      } else {

      }
    }
  }, [showOnMount]);

  const handleAcceptTerms = () => {
    if (accepted) {
      // Guardar en localStorage que aceptó los términos
      localStorage.setItem('termsAccepted', 'true');
      setShowModal(false);
    }
  };

  const handleCheckboxChange = (e) => {
    setAccepted(e.target.checked);
  };

  if (!showModal) {
    return null;
  }

  return (
    <>
      {/* Overlay oscuro */}
      <div className="terms-overlay" />
      
      {/* Modal */}
      <div className="terms-modal">
        <div className="terms-modal-content">
          <h2 className="terms-title">Términos y Condiciones</h2>
          
          <div className="terms-content">
            <div className="terms-item">
              <span className="terms-number">1.</span>
              <span className="terms-text">
                Los tickets serán enviados en un lapso de 24 horas. Tenemos un alto volumen de pagos por procesar.
              </span>
            </div>
            
            <div className="terms-item">
              <span className="terms-number">2.</span>
              <span className="terms-text">
                Solo podrán participar en nuestros sorteos personas naturales mayores de 18 años con nacionalidad venezolana o extranjeros que residan legalmente en Venezuela.
              </span>
            </div>
            
            <div className="terms-item">
              <span className="terms-number">3.</span>
              <span className="terms-text">
                Los premios deberán ser retirados en persona en la ubicación designada para cada sorteo. Suerte Solidaria ya solo realizará entregas personales en la dirección indicada para el primer premio o premio mayor.
              </span>
            </div>
            
            <div className="terms-item">
              <span className="terms-number">4.</span>
              <span className="terms-text">
                La compra mínima requerida para participar en nuestros sorteos es de 2 tickets. Los tickets serán asignados de manera aleatoria y los recibirá a través del correo electrónico proporcionado.
              </span>
            </div>
            
            <div className="terms-item">
              <span className="terms-number">5.</span>
              <span className="terms-text">
                Para reclamar tu premio tienes un lapso de 72 horas.
              </span>
            </div>
            
            <div className="terms-item">
              <span className="terms-number">6.</span>
              <span className="terms-text">
                Los ganadores aceptan aparecer en el contenido audiovisual del sorteo en Suerte solidaria ya mostrando su presencia en las redes y entrega de los premios. Esto es OBLIGATORIO.
              </span>
            </div>
            
            <div className="terms-item">
              <span className="terms-number">7.</span>
              <span className="terms-text">
                El resultado del premio mayor será tomado de la lotería super gana en sus horarios correspondientes.
              </span>
            </div>
          </div>

          <div className="terms-acceptance">
            <label className="checkbox-container">
              <input
                type="checkbox"
                checked={accepted}
                onChange={handleCheckboxChange}
                className="terms-checkbox"
              />
              <span className="checkbox-text">
                He leído y acepto los términos y condiciones
              </span>
            </label>
          </div>

          <div className="terms-actions">
            <button
              className={`terms-button ${accepted ? 'enabled' : 'disabled'}`}
              onClick={handleAcceptTerms}
              disabled={!accepted}
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </>
  );
});

TermsAndConditions.displayName = 'TermsAndConditions';

export default TermsAndConditions;
